import React from 'react';
import cx from 'classnames';
import T from 'i18n-react';
import Link from 'next/link';

import { Button } from '@motorway/mw-highway-code';

import styles from './SignUpSidebar.module.scss';

T.setTexts(require('../texts.json'));

const SignUpSidebar = () => {
	const classRoot = 'mw-signup-sidebar';

	return (
		<div className={styles[`${classRoot}-column`]}>
			<div className={styles[`${classRoot}-box`]}>
				<h3 className={cx('mw-title-title3', styles.title)}>{T.translate('signUpSidebar.title')}</h3>
				<p className={styles.para}>{T.translate('signUpSidebar.detail')}</p>
				<div className={styles.buttonWrapper}>
					<Link legacyBehavior passHref as="/signup" href="/signup">
						<Button fullWidth label={T.translate('signupPage.title')} />
					</Link>
				</div>
			</div>
		</div>
	);
};

export default SignUpSidebar;
